import React from 'react'

const UserPage:React.FC = () => {
    return (
        <div>
            <h2>The user Page</h2>
        </div>
    )
}

export default UserPage